import { QueryDtoOf } from '@40seas/entities/common';
import { Buyer } from '@40seas/entities/buyers';
import { CreditLine } from '@40seas/entities/credit-line';

export class CreditLineQueryDto extends QueryDtoOf(CreditLine, [Buyer]) {}
